import Home from './Cloud';
import Login from './Login';
import Curriculum from './curriculum';

const Api = {
  Home,
  Login,
  Curriculum
}

// 导出
export default Api
